import { iWACallLog } from "@sdk/wa-call-logs/wa-call-logs-model";
import _ from "lodash";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";
import {
  generateWACallLogOfContactQuery,
  generateWACallLogOfRingAgentQuery,
} from "./wa-call-logs.helpers";

export const {
  selectQueryMap: selectWACallLogQueryMap,
  selectEntityMap: selectWACallLogsMap,
  selectQueryMapAll: selectWACallLogsMapAll,
  selectQueryAllList: selectWACallLogsAllList,
  selectAllEntities: selectAllWACallLogs,
  selectAllEntitiesQuery: selectAllWACallLogsQuery,
  selectEntityById: selectWACallLogById,
  selectEntityQuery: selectWACallLogQuery,
  selectEntityQueryList: selectWACallLogQueryList,
} = CreateSelectorForEntities<iStore, iWACallLog>({
  sliceName: "WACallLogs",
});

export const selectWACallLogByConnectionId =
  (connectionId: string) => (state: iStore) => {
    return _.find(selectAllWACallLogs(state), {
      connectionId,
    });
  };

export const selectWACallLogsByContactId = (contactId: string) => {
  return selectWACallLogQuery(
    JSON.stringify(generateWACallLogOfContactQuery(contactId)),
  );
};

export const selectWACallLogsByRingAgentId = (ringAgentId: string) => {
  return selectWACallLogQuery(
    JSON.stringify(generateWACallLogOfRingAgentQuery(ringAgentId)),
  );
};
